import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rx-button, button[rx-button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  /** Button class */
  @Input() buttonClass = 'primary';

  /** Button type */
  @Input() type = 'button';

  /** Button text/label */
  @Input() text = '';

  /** Icon */
  @Input() icon = '';

  /** Icon position */
  @Input() iconPosition: 'left' | 'right' | '' = '';

  /** Disabled state */
  @Input() disabled = false;

  /** Smaller version */
  @Input() compact = false;

  /** Extend to full width */
  @Input() flexible = false;

  /** Button selected (only for button - subtle) */
  @Input() selected = false;

  /** Show loading spinner animation */
  @Input() isProcessing = false;

  /** On click*/
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClick = new EventEmitter<any>();
}
